// extracted by mini-css-extract-plugin
module.exports = {"container":"LastMatchTile_container__2fBjG","tournamentName":"LastMatchTile_tournamentName__1rpPh","desc":"LastMatchTile_desc__kcoSt"};